<div
  *ngIf="form"
  [formGroup]="form">
  <div
    class="repeatable-card-field"
    *ngFor="let item of items; let i = index">
    <ng-container
      [ngTemplateOutlet]="inputTemplate || defaultListTemplate"
      [ngTemplateOutletContext]="{ item: item, index: i }">
    </ng-container>

    <button
      mat-icon-button
      type="button"
      (click)="removeItemHandler(i)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <button
    mat-raised-button
    type="button"
    (click)="addItemHandler()">
    {{ 'Aggiungi' | translate }}
  </button>

  <ng-template
    #defaultListTemplate
    let-index="index">
    <mat-form-field>
      <input
        matInput
        [placeholder]="'Elemento'"
        [formControlName]="index">
    </mat-form-field>
  </ng-template>
</div>
